<div class="category-grid-container mb-16" [ngClass]="getClassGrid$ | async">
    @if (showNoResults$ | async) {
        <category-noresults></category-noresults>
    }

    @if ((isLoadedCategory$ | async) === true) {
        @switch (gridType$ | async) {
            @case (1) {
                <app-grid-studio
                    [category]="getCategory$ | async"
                    [isCategoryNew]="isCategoryNew$ | async"
                    [gridElements]="getGridElements$ | async"
                    [pageGridElements]="pageGridElements$ | async"
                    [seoCategoryName]="seoCategoryName$ | async"
                    [defaultImageTypes]="elementDefaultImageTypes$ | async"
                    [place]="'PRODUCT_GRID'"
                    [showMediaCarousel]="mediaCarouselActive$ | async"
                    [showLastSizesGrid]="showLastSizesGrid"
                    (loadNextPageEvent)="onScrollGridStudio()"
                ></app-grid-studio>
            }
            @case (2) {
                <app-grid-default-2
                    [productIds]="getPageProductIds$ | async"
                    [category]="getCategory$ | async"
                    [isCategoryNew]="isCategoryNew$ | async"
                    [defaultImageTypes]="elementDefaultImageTypes$ | async"
                    [isRtl]="isRtl$ | async"
                    [seoCategoryName]="seoCategoryName$ | async"
                    [place]="'PRODUCT_GRID'"
                    [showMediaCarousel]="mediaCarouselActive$ | async"
                    [showLastSizesGrid]="showLastSizesGrid"
                    (loadNextPageEvent)="onScrollGridDefault()"
                ></app-grid-default-2>
            }
            @case (3) {
                <app-grid-default-3
                    [productIds]="getPageProductIds$ | async"
                    [category]="getCategory$ | async"
                    [isCategoryNew]="isCategoryNew$ | async"
                    [defaultImageTypes]="elementDefaultImageTypes$ | async"
                    [isRtl]="isRtl$ | async"
                    [seoCategoryName]="seoCategoryName$ | async"
                    [place]="'PRODUCT_GRID'"
                    [showMediaCarousel]="mediaCarouselActive$ | async"
                    [showLastSizesGrid]="showLastSizesGrid"
                    (loadNextPageEvent)="onScrollGridDefault()"
                ></app-grid-default-3>
            }
        }

        @defer (on viewport) {
            @if (enableNewCollection$ | async) {
                <app-grid-new-collection
                    [category]="getCategory$ | async"
                    [isCategoryNew]="isCategoryNew$ | async"
                    [gridType]="gridType$ | async"
                ></app-grid-new-collection>
            }
        } @placeholder {
            <div class="alterative-grids-container"></div>
        }
    }
</div>

@if (enabledDiscountDisclaimer$ | async) {
    <span class="text-l c-dark-grey pr-body pl-body pb-32 mt-16">
        {{ 'dev.product.discountDisclaimer' | translate }}
    </span>
}
